<template >
    <div class="card">
        <div class="card-content">
            <div class="card-body">
                <h3>Coupon</h3>
                <div class="alert alert-success" role="alert">
                    <strong> </strong>
                </div>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" aria-labelledby="account-pill-info" aria-expanded="false">
                        <div class="form-group col-md-12 col-12">
                            <label for="coupon">Coupon</label>
                            <input type="text" name="coupon" id="coupon" class="form-control" v-model="coupon"/>
                            <span v-if="vuelidate.coupon.$error" class="error mt-1 text-danger">Coupon {{vuelidate.coupon.$errors[0].$message.toLowerCase()}}.</span>
                            <div v-if="Object.keys(billingStore.error).length">
                                <div v-for="err,index in billingStore.error">
                                    <div v-for="er,index in err" class="error text-danger" v-if="err">
                                        {{er}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12 col-12">
                            <button
                                type="button"
                                class="btn btn-primary col-12"
                                :class="{'applying':billingStore.applying}"
                                @click.once="applyCoupon($event)"
                                :key="billingStore.btnClicked"
                            >
                                {{ billingStore.couponBtn }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useBillingStore } from '../../stores/BillingStore'
import axios from 'axios'
export default{
    name:'CreditfixrrCoupon',
    setup(){
        const coupon = ref(null);
        return{
            vuelidate: useVuelidate(),
            coupon,
            billingStore:useBillingStore()
        }
    },
    validations () {
        return {
            coupon : {
                required
            }
        }
    },
    methods:{
        applyCoupon() {
           this.vuelidate.$validate();
           if(this.vuelidate.$errors.length <= 0){
                this.billingStore.couponBtn = 'Applying...';
                this.billingStore.applying=true;
                let $this = this;
                const route = $this.$router.resolve(
                    {
                        name: 'billing-coupon'
                    }
                );
                axios.post(route.href,{coupon:this.coupon}).then(({data})=>{
                    if(!data.error){
                        $this.billingStore.btnClicked++;
                        $this.billingStore.applying=false
                        toastr.success(data.message,'Coupon Success');
                        $this.billingStore.couponBtn = 'Apply Coupon';
                        $this.billingStore.error = "";
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                        $this.clearForm;
                    }else{
                        $this.billingStore.btnClicked++
                        $this.billingStore.applying=false
                        $this.billingStore.error = data.message
                        $this.billingStore.couponBtn = 'Apply Coupon';
                    }
                }).catch(error=>{
                    $this.billingStore.btnClicked++
                    $this.billingStore.applying=false
                    $this.billingStore.couponBtn = 'Apply Coupon';
                })
           }else{
                this.billingStore.btnClicked++
                this.billingStore.applying=false
           }

        },
        clearForm(){
            this.coupon = "";
        }
    }
}
</script>
<style>
.applying{
    background: #6ac981 !important;
    cursor: wait;
    color: white !important;
}
</style>
